
import React from 'react';
import { Sun, Moon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import AuthButton from './AuthButton';

const WeatherHeader = ({ theme, onThemeToggle, showBanner }) => {
  return (
    <>
      {/* Fixed top-right controls */}
      <div className="fixed top-4 right-4 z-50 flex items-center space-x-3">
        <Button 
          variant="ghost" 
          onClick={onThemeToggle} 
          className="p-2 text-gray-800 dark:text-gray-200 hover:bg-gray-100/50 dark:hover:bg-gray-700/50 rounded-full"
        >
          {theme === 'light' ? <Moon className="h-4 w-4" /> : <Sun className="h-4 w-4" />}
        </Button>
        <AuthButton />
      </div>
      
      {/* Spacer for banner if needed */}
      {showBanner && <div className="mt-36" />}
    </>
  );
};

export default WeatherHeader;
